import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ModernCouple() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="moderncouple" className="relative w-full bg-background py-[120px] border-y border-border overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {}
          <div ref={ref} className={cn("relative w-full transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
            <div className="relative w-full overflow-hidden rounded-sm shadow-2xl shadow-primary/5 border border-border/50">
              <AspectRatio ratio={3 / 4}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554289/img/professional_indian_couple_lifestyle.png" alt="Professional Indian couple sharing a moment of trust and clarity" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
              </AspectRatio>
              {}
              <div className="absolute inset-0 bg-primary/5 pointer-events-none" />
            </div>
          </div>

          {}
          <div className={cn("flex flex-col justify-center space-y-8 transition-all duration-1000 delay-300 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
            <div className="space-y-6">
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground leading-[1.1] tracking-tight">Trust is the bridge between love and a lifetime</h2>
              <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed max-w-lg">Love is a promise. We make sure it starts on a foundation you can truly rely on: <b>informed, secure, and stress-free.</b></p>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm px-8 h-14 text-base font-medium tracking-wide shadow-sm transition-all duration-300">
                <Link to="/contact">
                  Schedule Private Consultation
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>

            {}
            <div className="w-16 h-px bg-border mt-8" />
          </div>
        </div>
      </div>
    </section>;
}